import { Component, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '../base-component/base.component';
import { ThemesService } from '../../../core/services/themes.service';
import { CssThemes } from '../../common';

@Component({
  selector: 'app-no-permission',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
  ],
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss']
})
export class NoPermissionComponent extends BaseComponent implements OnInit {
  currentTheme: CssThemes = this.themesService.currentTheme;
  CssThemes = CssThemes;

  constructor(injector: Injector, private themesService: ThemesService) {
    super([], injector)
   }

  ngOnInit(): void {

  }

}
